import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import DataTable from './../../shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import { entityInterfaceSearchFields } from "../utils/searchFields";

const EntityInterfacesPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    data = [],
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    categoryList,
    suppressSearchForm = false,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("entityInterfaces.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("entityInterfaces.list.category"),
        id: "category",
        sortable: true,
        accessor: interfaceInstance => interfaceInstance.category.value
     }, {
        Header: I18n.t("entityInterfaces.list.lastReading"),
        accessor: "lastReading",
        sortable: false
    }, {
        Header: I18n.t("entityInterfaces.list.lastCommunication"),
        accessor: "lastCommunicationTimestamp",
        sortable: true
    }];
    return <div className="page_background">
        {!suppressSearchForm &&
            <SearchForm
                hideAddButton={true}
                content={entityInterfaceSearchFields(searchFieldsValues, categoryList)}
                universalSearchField={universalSearchField}
                handleFieldChange={handleSearchFieldChange}
                handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
                handleClear={handleSearchClear}
                handleSubmit={handleSearchSubmit}
            />}
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={false}
            />
        </div>
    </div>
};

EntityInterfacesPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default EntityInterfacesPage;